import Button from '@/ui/buttons/button/Button';
import DefaultModal from '@/ui/modals/defaultModal';
import Typo from '@/ui/typo/Typo';
import logo from '@/assets/logo.svg';
import { Fragment, useEffect } from 'react';
import { COLORS } from '@/styles/colorTheme';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';

const SigninCTAModal = ({ open = false, onClose = () => {}, redirection = '' }) => {
  const [t] = useTranslation('signIn');

  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]);

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" style={{ zIndex: 1000 }} />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 1000 }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={logo} width="35px" />
                  <Typo variant="h1" sx={{ marginLeft: '8px' }}>
                    ESG LENS
                  </Typo>
                </div>
                <div style={{ marginLeft: '4px' }}>
                  <Typo variant="b2" color={COLORS.Text200}>
                    AI-Powered ESG Insights
                  </Typo>
                </div>

                <div className="mt-4">
                  <div className="mt-4">
                    <div>
                      <Typo variant="h1">{t('Need ESG Insights?')}</Typo>
                    </div>
                    <div>
                      <Typo variant="b2" color={COLORS.Text200}>
                        {t('Please login and enjoy the following features for free.')}
                      </Typo>
                    </div>
                  </div>
                  <div className="my-8 mx-4 space-y-4">
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <Typo>{t('Create your own portfolio')}</Typo>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <Typo>{t('Monitor your portfolios')}</Typo>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <Typo>{t('ESG categorized news')}</Typo>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <Typo>{t('Benchmark analysis')}</Typo>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <Typo>{t('Timeline analysis')}</Typo>
                    </div>
                  </div>
                </div>

                <div>
                  <Button
                    sx={{ width: '100%' }}
                    onClick={() => (window.location.href = `/signin/${redirection}`)}
                  >
                    {t('Get Started')}
                  </Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default SigninCTAModal;
